<template>
  <b-field grouped class="wrapper-manage-unity-search">
    <b-dropdown ref="filterDropdown" class="control" aria-role="list">
      <template slot="trigger">
        <b-button class="custom-dropdown-button" iconLeft="tune">{{
          General.FILTERS
        }}</b-button>
      </template>
      <b-dropdown-item custom>
        <section class="filter-dropdown">
          <b-loading isFullPage :active="isLoading" />
          <div class="is-flex is-justify-content-space-between">
            <div class="subtitle has-text-weight-semibold">
              {{ General.FILTERS }}
            </div>
            <div class="cursor-pointer" @click.stop="close">
              <b-icon icon="close" type="is-grey-light" />
            </div>
          </div>
          <div
            v-for="(_, index) in currentFilterList"
            :key="index"
            class="filter-container is-vcentered"
          >
            <b-select
              v-model="currentFilterList[index].type"
              :placeholder="General.SELECT_FILTER"
              expanded
              class="filter-select"
              @input="value => onSelectOption(value, index)"
            >
              <option
                v-for="(option, indexOptions) in checkSelect(index)"
                :key="indexOptions"
                :value="option.type"
              >
                {{ option.name }}</option
              >
            </b-select>
            <div class="filter-input">
              <b-select
                v-if="currentFilterList[index].type === `CONFIGURATION`"
                v-model="currentFilterList[index].data"
                :placeholder="General.PLACEHOLDER.SELECT_CONFIGURATION"
                class="is-full"
              >
                <option
                  v-for="option in getConfigurationOptions"
                  :key="option.value"
                  :value="option"
                >
                  {{ option.name }}
                </option>
              </b-select>
              <b-select
                v-else-if="currentFilterList[index].type === `STATUS`"
                v-model="currentFilterList[index].data"
                :placeholder="General.PLACEHOLDER.SELECT_SITUATION"
                class="is-full"
              >
                <option
                  v-for="option in statusOptions"
                  :key="option.value"
                  :value="option"
                >
                  {{ option.name }}
                </option>
              </b-select>
              <b-input
                v-else-if="currentFilterList[index].type === `UNITY`"
                :value="currentFilterList[index].data.name"
                :placeholder="General.PLACEHOLDER.SEARCH_CAPACITY"
                expanded
                @input="value => onSetUnity(value, index)"
              />
              <b-input v-else expanded disabled />
            </div>
            <div
              class="filter-delete cursor-pointer"
              @click.stop="
                checkSingleFilter(index)
                  ? clearFilter(index)
                  : removeFilter(index)
              "
            >
              <b-icon
                icon="minus-circle-outline"
                :type="
                  checkSingleFilter(index)
                    ? isContrast
                      ? 'is-white-dark'
                      : 'is-grey'
                    : ''
                "
              />
            </div>
          </div>
          <div class="columns">
            <div
              class="new-filter column cursor-pointer"
              @click.stop="addFilter()"
            >
              <b-icon
                icon="plus-circle"
                :type="isContrast ? 'is-white-dark' : 'is-green-lawn'"
              />
              <span class="has-text-weight-semibold">{{
                General.ADD_FILTER
              }}</span>
            </div>
          </div>
          <section class="is-flex is-justify-content-space-between mt-20">
            <div class="is-flex is-align-items-center">
              <b-checkbox
                v-if="tabPersistName"
                v-model="fixFilters"
                :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                class="has-text-weight-semibold has-text-color-7"
                @input="deleteFilters"
              >
                {{ App.PainelSearch.FIX_FILTERS }}
              </b-checkbox>
            </div>
            <div class="buttons">
              <b-button
                class="has-text-weight-semibold"
                :type="isContrast ? 'is-white-dark' : 'is-green-lawn'"
                @click.stop="applyFilters"
                >{{ General.APPLY }}</b-button
              >
              <b-button
                class="has-text-weight-semibold"
                :type="isContrast ? 'is-white-dark' : 'is-orange'"
                outlined
                @click.stop="close"
                >{{ General.CANCEL }}</b-button
              >
            </div>
          </section>
        </section>
      </b-dropdown-item>
    </b-dropdown>
    <div class="flex-1 container-input-tags">
      <b-input
        expanded
        icon="magnify"
        :placeholder="getPlaceholderText"
        @input="
          value => {
            setIsLoadingManageUnity(true);
            inputSearch(value);
          }
        "
      />
      <div class="mt-10 container-tags">
        <b-taglist v-if="filterTags">
          <template v-if="filterTags.configuration">
            <b-tag
              v-for="(filter, index) in filterTags.configuration"
              :key="index"
              :type="isContrast ? 'is-white-dark' : 'is-blue-prussian'"
              rounded
              closable
              @close="removeFilterTag('configuration', index)"
            >
              {{ General.TYPE }}:
              {{ filter.name }}
            </b-tag>
          </template>
          <template v-if="filterTags.status">
            <b-tag
              key="status"
              :type="isContrast ? 'is-white-dark' : 'is-blue-prussian'"
              rounded
              closable
              @close="removeFilterTag('status')"
            >
              {{ General.STATUS }}:
              {{ filterTags.status.name }}
            </b-tag>
          </template>
          <template v-if="filterTags.unity">
            <b-tag
              v-for="(unity, index) in filterTags.unity"
              :key="`unity_${index}`"
              :type="isContrast ? 'is-white-dark' : 'is-blue-prussian'"
              rounded
              closable
              @close="removeFilterTag('unity', index)"
            >
              {{ General.UNITY }}:
              {{ unity.name }}
            </b-tag>
          </template>
        </b-taglist>
      </div>
    </div>
  </b-field>
</template>

<script>
import { debounce } from "lodash";

import { App, General } from "@/utils/constants";
import { mapGetters, mapMutations } from "vuex";

import {
  CONFIGURATION_UNITY_OPTIONS as configurationOptions,
  STATUS_UNITY_OPTIONS as statusOptions
} from "@/utils/enumerate";

import {
  setPersistFilters,
  getPersistFilters,
  removePersistFilters
} from "@/plugins/indexDB";

export default {
  name: "ManageUnitySearch",
  props: {
    itensFilter: {
      type: Array,
      default: () => ["CONFIGURATION", "STATUS", "UNITY"]
    },
    tabPersistName: {
      type: String,
      default: ""
    },
    isManageOrgan: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      App,
      General,
      configurationOptions,
      statusOptions,
      isLoading: false,
      fixFilters: false,
      currentFilterList: [
        {
          type: null,
          data: null
        }
      ],
      filters: [],
      searchValue: "",
      filterPart: "",
      dateRange: { start: new Date(), end: new Date() },
      options: [
        { name: General.CONFIG_SINGULAR, type: "CONFIGURATION" },
        { name: General.STATUS, type: "STATUS" },
        { name: General.UNITY, type: "UNITY" }
      ]
    };
  },

  computed: {
    ...mapGetters({
      isContrast: "isContrast",
      getManageUnityFilters: "getManageUnityFilters"
    }),

    optionsList() {
      const options = this.options.filter(item =>
        this.itensFilter.includes(item.type)
      );

      return options;
    },

    filterData() {
      return {
        filters: this.filters,
        searchValue: this.searchValue
      };
    },

    filterTags() {
      return this.getManageUnityFilters.filters;
    },

    getPlaceholderText() {
      return this.isManageOrgan
        ? General.PLACEHOLDER.SEARCH_FOR_ORGAN
        : General.PLACEHOLDER.SEARCH_FOR_UNITY;
    },

    getConfigurationOptions() {
      return this.isManageOrgan
        ? [configurationOptions["CORE_PROTOCOL"]]
        : configurationOptions;
    }
  },

  async beforeMount() {
    const persistFilters = await getPersistFilters({
      name: this.tabPersistName
    });

    if (persistFilters.length) {
      this.fixFilters = true;
      this.currentFilterList = persistFilters;
      this.applyFilters(false);
    }

    const observerVisible = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && this.fixFilters) {
          this.snackToast.open({
            message: App.PainelSearch.HAS_FIX_FILTER,
            type: "is-info",
            duration: 8000
          });
        }
      });
    });
    observerVisible.observe(this.$el);
  },

  beforeDestroy() {
    this.setManageUnityFilters({});
  },

  methods: {
    ...mapMutations({
      setManageUnityFilters: "setManageUnityFilters",
      setIsLoadingManageUnity: "setIsLoadingManageUnity"
    }),

    checkSingleFilter(filterIndex) {
      return filterIndex === 0 && this.currentFilterList.length === 1;
    },

    onSelectOption(option, index) {
      this.currentFilterList[index] = {
        type: option,
        data: { name: "" }
      };
      this.currentFilterList = [...this.currentFilterList];
    },

    onSetUnity(name, index) {
      this.currentFilterList[index].data = { name };
    },

    addFilter() {
      this.currentFilterList.push({
        type: null,
        data: null
      });
    },

    removeFilter(index) {
      if (this.currentFilterList.length > 1)
        this.currentFilterList.splice(index, 1);
    },

    clearFilter(index) {
      this.currentFilterList[index] = { type: null, data: null };
      this.currentFilterList = [...this.currentFilterList];
    },

    applyFilters(close = false) {
      if (this.fixFilters && this.tabPersistName)
        setPersistFilters({
          name: this.tabPersistName,
          filters: this.currentFilterList
        });

      this.filters = this.currentFilterList.reduce((acc, actual, filterID) => {
        if (
          !actual.data?.id &&
          !actual.data?.displayText &&
          !actual.data?.start &&
          !actual.data?.name &&
          !actual.data?.length
        )
          return acc;

        const key = {
          CONFIGURATION: "configuration",
          STATUS: "status",
          UNITY: "unity"
        }[actual.type];

        const data = {
          ...actual.data,
          filterID
        };

        if (acc[key]) acc[key].push(data);
        else acc[key] = ["status"].includes(key) ? data : [data];

        return acc;
      }, {});

      this.setManageUnityFilters(this.filterData);
      close && this.close();
    },

    close() {
      this.$refs.filterDropdown?.toggle();
    },

    checkSelect(actualIndex) {
      const statusIndex = this.currentFilterList.findIndex(
        filter => filter.type === "STATUS"
      );
      return this.optionsList.filter(
        filter =>
          !["STATUS"].includes(filter.type) ||
          (filter.type === "STATUS" &&
            (statusIndex < 0 || statusIndex === actualIndex))
      );
    },

    removeFilterTag(type, index) {
      if (["status"].includes(type)) {
        this.updateList(this.filters[type]);
        delete this.filters[type];
        this.filters = { ...this.filters };
      } else {
        this.updateList(this.filters[type][index]);
        this.filters[type] = [...this.filters[type]].filter(
          (_, index_item) => index_item !== index
        );
        if (!this.filters[type]?.length) {
          delete this.filters[type];
          this.filters = { ...this.filters };
        }
      }
      this.setManageUnityFilters(this.filterData);
    },

    inputSearch: debounce(function(text) {
      this.searchValue = text;
      this.setManageUnityFilters(this.filterData);
    }, 500),

    deleteFilters(status) {
      if (!status) {
        removePersistFilters(this.tabPersistName);
      }
    },

    updateList({ filterID }) {
      if (this.fixFilters && this.tabPersistName) {
        this.currentFilterList = this.currentFilterList.filter(
          (_, id) => filterID !== id
        );
        if (this.currentFilterList.length)
          setPersistFilters({
            name: this.tabPersistName,
            filters: this.currentFilterList
          });
        else {
          removePersistFilters(this.tabPersistName);
          this.currentFilterList = [
            {
              type: null,
              data: {
                displayText: ""
              }
            }
          ];
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";
.wrapper-manage-unity-search {
  margin: 10px 0 20px 0 !important;
}

.filter-dropdown {
  display: flex;
  flex-direction: column;

  @media screen and (min-width: 1024px) {
    min-width: 600px;
  }

  .new-filter {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 5px;
    @media screen and (min-width: $tablet) {
      margin-right: calc(100% / 12 + 10px);
    }
  }
}

.dropdown-item:hover {
  background-color: $color-1 !important;
}

.autocomplete .dropdown-item:hover {
  background-color: $color-2 !important;
}

@media screen and (max-width: 768px) {
  .container-input-tags {
    display: flex;
    flex-direction: column-reverse;
    gap: 5px;
    .container-tags {
      margin-top: 0 !important;
    }
  }

  .buttons {
    margin-top: 0 !important;
    flex-wrap: nowrap;
  }
}

.filter-select {
  grid-area: filter-select;
}

.filter-input {
  grid-area: filter-input;
}

.filter-delete {
  align-self: center;
  grid-area: filter-delete;
}

.filter-container {
  display: grid;
  gap: 10px;
  margin-bottom: 10px;
  grid-template-columns: 4fr 7fr 1fr;
  grid-template-rows: auto;
  grid-template-areas: "filter-select filter-input filter-delete";

  @media screen and (max-width: 768px) {
    border-bottom: 1px solid $color-3;
    padding-bottom: 5px;
    grid-template-columns: 11fr 1fr;
    grid-template-rows: auto;
    grid-template-areas:
      "filter-select filter-delete"
      "filter-input filter-input";
  }
}
</style>

<style lang="scss">
@import "@/assets/scss/variables";
.wrapper-manage-unity-search {
  .dropdown-menu {
    top: 2.5rem !important;
  }
  .is-full .select {
    &,
    select {
      width: 100%;
    }
  }
  @media screen and (max-width: 768px) {
    .field {
      flex-direction: column;
      gap: 5px;

      .dropdown {
        margin-right: 0 !important;
        .dropdown-trigger,
        .button {
          width: 100%;
        }
      }
    }
  }
}
</style>
